"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMargin = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _variables = require("./variables.js");

var getMargin = function getMargin(marginProp, side) {
  if (marginProp && (0, _typeof2["default"])(marginProp) === "object") {
    return marginProp[side] && _variables.spaces[marginProp[side]] || "0px";
  } else {
    return marginProp && _variables.spaces[marginProp] || "0px";
  }
};

exports.getMargin = getMargin;